var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438",
    transform: "translate(-852 -304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4743",
    "data-name": "Path 4743",
    d: "M0,0H24V24H0Z",
    transform: "translate(852 304)",
    fill: "#e6e6e6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437",
    transform: "translate(248.52 -235.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 22.346,
    height: 17.077,
    rx: 1.064,
    transform: "translate(604.338 542.121)",
    fill: "none",
    stroke: "#363639",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    "data-name": "Path 4744",
    d: "M605.785,559.988l6.885-9.654,3.769,4.827,2.5-2.327,6.692,7.154",
    transform: "translate(-0.139 -0.79)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 1.654,
    cy: 1.654,
    r: 1.654,
    transform: "translate(619.068 545.929)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.fef3349e615bd3d4b544cf0cf3f3fdee.svg";
export { ForwardRef as ReactComponent };